// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  position: relative;
  width: 75px;
  height: 100px;
  left: calc(50% - 37.5px);
}
.loader__bar {
  position: absolute;
  bottom: 0;
  width: 10px;
  height: 50%;
  background: rgb(214, 210, 255);
  transform-origin: center bottom;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
}
.loader__bar:nth-child(1) {
  left: 0px;
  transform: scale(1, 0.2);
  animation: barUp1 4s infinite;
}
.loader__bar:nth-child(2) {
  left: 15px;
  transform: scale(1, 0.4);
  animation: barUp2 4s infinite;
}
.loader__bar:nth-child(3) {
  left: 30px;
  transform: scale(1, 0.6);
  animation: barUp3 4s infinite;
}
.loader__bar:nth-child(4) {
  left: 45px;
  transform: scale(1, 0.8);
  animation: barUp4 4s infinite;
}
.loader__bar:nth-child(5) {
  left: 60px;
  transform: scale(1, 1);
  animation: barUp5 4s infinite;
}
.loader__ball {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 10px;
  height: 10px;
  background: #897fff;
  border-radius: 50%;
  animation: ball 4s infinite;
}

@keyframes ball {
  0% {
    transform: translate(0, 0);
  }
  5% {
    transform: translate(8px, -14px);
  }
  10% {
    transform: translate(15px, -10px);
  }
  17% {
    transform: translate(23px, -24px);
  }
  20% {
    transform: translate(30px, -20px);
  }
  27% {
    transform: translate(38px, -34px);
  }
  30% {
    transform: translate(45px, -30px);
  }
  37% {
    transform: translate(53px, -44px);
  }
  40% {
    transform: translate(60px, -40px);
  }
  50% {
    transform: translate(60px, 0);
  }
  57% {
    transform: translate(53px, -14px);
  }
  60% {
    transform: translate(45px, -10px);
  }
  67% {
    transform: translate(37px, -24px);
  }
  70% {
    transform: translate(30px, -20px);
  }
  77% {
    transform: translate(22px, -34px);
  }
  80% {
    transform: translate(15px, -30px);
  }
  87% {
    transform: translate(7px, -44px);
  }
  90% {
    transform: translate(0, -40px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes barUp1 {
  0% {
    transform: scale(1, 0.2);
  }
  40% {
    transform: scale(1, 0.2);
  }
  50% {
    transform: scale(1, 1);
  }
  90% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 0.2);
  }
}
@keyframes barUp2 {
  0% {
    transform: scale(1, 0.4);
  }
  40% {
    transform: scale(1, 0.4);
  }
  50% {
    transform: scale(1, 0.8);
  }
  90% {
    transform: scale(1, 0.8);
  }
  100% {
    transform: scale(1, 0.4);
  }
}
@keyframes barUp3 {
  0% {
    transform: scale(1, 0.6);
  }
  100% {
    transform: scale(1, 0.6);
  }
}
@keyframes barUp4 {
  0% {
    transform: scale(1, 0.8);
  }
  40% {
    transform: scale(1, 0.8);
  }
  50% {
    transform: scale(1, 0.4);
  }
  90% {
    transform: scale(1, 0.4);
  }
  100% {
    transform: scale(1, 0.8);
  }
}
@keyframes barUp5 {
  0% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 0.2);
  }
  90% {
    transform: scale(1, 0.2);
  }
  100% {
    transform: scale(1, 1);
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/home/convert/convert-2/convert-2.component.scss"],"names":[],"mappings":"AAKA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;AAJF;AAME;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,8BAfQ;EAgBR,+BAAA;EACA,wCAAA;AAJJ;AAOM;EACE,SAAA;EACA,wBAAA;EACA,6BAAA;AALR;AAEM;EACE,UAAA;EACA,wBAAA;EACA,6BAAA;AAAR;AAHM;EACE,UAAA;EACA,wBAAA;EACA,6BAAA;AAKR;AARM;EACE,UAAA;EACA,wBAAA;EACA,6BAAA;AAUR;AAbM;EACE,UAAA;EACA,sBAAA;EACA,6BAAA;AAeR;AAVE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAjCS;EAkCT,kBAAA;EACA,2BAAA;AAYJ;;AARA;EACE;IACE,0BAAA;EAWF;EATA;IACE,gCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,6BAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,iCAAA;EAWF;EATA;IACE,gCAAA;EAWF;EATA;IACE,8BAAA;EAWF;EATA;IACE,0BAAA;EAWF;AACF;AARA;EACE;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,sBAAA;EAUF;EARA;IACE,sBAAA;EAUF;EARA;IACE,wBAAA;EAUF;AACF;AARA;EACE;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;AACF;AARA;EACE;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;AACF;AARA;EACE;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;AACF;AARA;EACE;IACE,sBAAA;EAUF;EARA;IACE,sBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EARA;IACE,sBAAA;EAUF;AACF;AACA,41LAA41L","sourcesContent":["// Variables\n$bar-color: rgb(214, 210, 255);\n$ball-color: #897fff;\n$bg-color: rgba(255, 255, 255, 0);\n\n.loader {\n  position: relative;\n  width: 75px;\n  height: 100px;\n  left: calc(50% - (75px / 2));\n\n  &__bar {\n    position: absolute;\n    bottom: 0;\n    width: 10px;\n    height: 50%;\n    background: $bar-color;\n    transform-origin: center bottom;\n    box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);\n\n    @for $i from 1 through 5 {\n      &:nth-child(#{$i}) {\n        left: ($i - 1) * 15px;\n        transform: scale(1, $i * 0.2);\n        animation: barUp#{$i} 4s infinite;\n      }\n    }\n  }\n\n  &__ball {\n    position: absolute;\n    bottom: 10px;\n    left: 0;\n    width: 10px;\n    height: 10px;\n    background: $ball-color;\n    border-radius: 50%;\n    animation: ball 4s infinite;\n  }\n}\n\n@keyframes ball {\n  0% {\n    transform: translate(0, 0);\n  }\n  5% {\n    transform: translate(8px, -14px);\n  }\n  10% {\n    transform: translate(15px, -10px);\n  }\n  17% {\n    transform: translate(23px, -24px);\n  }\n  20% {\n    transform: translate(30px, -20px);\n  }\n  27% {\n    transform: translate(38px, -34px);\n  }\n  30% {\n    transform: translate(45px, -30px);\n  }\n  37% {\n    transform: translate(53px, -44px);\n  }\n  40% {\n    transform: translate(60px, -40px);\n  }\n  50% {\n    transform: translate(60px, 0);\n  }\n  57% {\n    transform: translate(53px, -14px);\n  }\n  60% {\n    transform: translate(45px, -10px);\n  }\n  67% {\n    transform: translate(37px, -24px);\n  }\n  70% {\n    transform: translate(30px, -20px);\n  }\n  77% {\n    transform: translate(22px, -34px);\n  }\n  80% {\n    transform: translate(15px, -30px);\n  }\n  87% {\n    transform: translate(7px, -44px);\n  }\n  90% {\n    transform: translate(0, -40px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes barUp1 {\n  0% {\n    transform: scale(1, 0.2);\n  }\n  40% {\n    transform: scale(1, 0.2);\n  }\n  50% {\n    transform: scale(1, 1);\n  }\n  90% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(1, 0.2);\n  }\n}\n@keyframes barUp2 {\n  0% {\n    transform: scale(1, 0.4);\n  }\n  40% {\n    transform: scale(1, 0.4);\n  }\n  50% {\n    transform: scale(1, 0.8);\n  }\n  90% {\n    transform: scale(1, 0.8);\n  }\n  100% {\n    transform: scale(1, 0.4);\n  }\n}\n@keyframes barUp3 {\n  0% {\n    transform: scale(1, 0.6);\n  }\n  100% {\n    transform: scale(1, 0.6);\n  }\n}\n@keyframes barUp4 {\n  0% {\n    transform: scale(1, 0.8);\n  }\n  40% {\n    transform: scale(1, 0.8);\n  }\n  50% {\n    transform: scale(1, 0.4);\n  }\n  90% {\n    transform: scale(1, 0.4);\n  }\n  100% {\n    transform: scale(1, 0.8);\n  }\n}\n@keyframes barUp5 {\n  0% {\n    transform: scale(1, 1);\n  }\n  40% {\n    transform: scale(1, 1);\n  }\n  50% {\n    transform: scale(1, 0.2);\n  }\n  90% {\n    transform: scale(1, 0.2);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
